import axios from "axios";
import { GET_DIAMOND_RAIN_HISTORY, GET_DIAMOND_RAIN_STATS } from "./type";
import { Toast } from "../../util/Toast";

export const getDiamondRainHistory = (page = 1, limit = 20, startDate = null, endDate = null) => (dispatch) => {
    let url = `/diamondRain/admin/history?page=${page}&limit=${limit}`;

    if (startDate && endDate && startDate !== "ALL" && endDate !== "ALL") {
        url += `&startDate=${startDate}&endDate=${endDate}`;
    }

    axios
        .get(url)
        .then((res) => {
            if (res.data.status) {
                dispatch({
                    type: GET_DIAMOND_RAIN_HISTORY,
                    payload: {
                        history: res.data.history,
                        pagination: res.data.pagination
                    }
                });
            } else {
                Toast("error", res.data.message);
            }
        })
        .catch((error) => {
            console.log("error", error);
            Toast("error", "Failed to load Diamond Rain History");
        });
};


export const getDiamondRainStats = (startDate = null, endDate = null) => (dispatch) => {
    let url = "/diamondRain/admin/stats";

    if (startDate && endDate && startDate !== "ALL" && endDate !== "ALL") {
        url += `?startDate=${startDate}&endDate=${endDate}`;
    }

    axios
        .get(url)
        .then((res) => {
            if (res.data.status) {
                dispatch({ type: GET_DIAMOND_RAIN_STATS, payload: res.data.stats });
            } else {
                Toast("error", res.data.message);
            }
        })
        .catch((error) => {
            console.log("error", error);
            Toast("error", "Failed to load Diamond Rain Stats");
        });
};
